<template>
  <LayoutCNMenuDesktopContainer>
    <template #left>
      <KeepAlive>
        <li
          v-for="item in formatProductGroupMenu"
          :key="hash(item)"
          :class="item.level === 'group' ? 'mb-4' : 'mb-0.5'"
          class="last:mb-0"
        >
          <div v-if="item.level === 'group'">
            <div>
              <MenuLink v-if="validIsNuxtLink(item)" :data="item" />
              <p
                v-if="!validIsNuxtLink(item)"
                class="mb-1 px-2 py-1 text-sm font-bold text-gray-600"
              >
                {{ item.name }}
              </p>
            </div>
            <ul v-if="item.subMenus.length">
              <li
                v-for="subItem in item.subMenus"
                :key="hash(subItem)"
                class="mb-0.5 last:mb-0"
              >
                <MenuLink
                  :data="subItem"
                  :current="current === subItem.code"
                  @click="handleClick(subItem)"
                />
              </li>
            </ul>
          </div>
          <MenuLink
            v-else
            :data="item"
            :current="current === item.code"
            @click="handleClick(item)"
          />
        </li>
      </KeepAlive>
    </template>
    <template #right>
      <LayoutCNMenuDesktopContent
        v-if="currentData"
        :type="menuName.CN_PRODUCTS"
        :link="currentData?.link"
      >
        <KeepAlive>
          <LayoutCNMenuDesktopCategory
            v-for="item in formatProductsMenu"
            v-show="current === item.code"
            :key="hash(item)"
            :list="item.subMenus"
          />
        </KeepAlive>
      </LayoutCNMenuDesktopContent>
    </template>
  </LayoutCNMenuDesktopContainer>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import MenuLink from '@/components/Layout/CNMenu/Desktop/MenuLink.vue';
  import validIsNuxtLink from '@/components/Layout/Menu/validIsNuxtLink';
  import type { IFormatProductMenu } from '@/stores/menuStore';

  const menuStore = useMenuStore();
  const { menuName, formatProductsMenu, formatProductGroupMenu } =
    storeToRefs(menuStore);

  const current = ref<string>(formatProductsMenu.value[0]?.code || '');

  const currentData = computed((): IFormatProductMenu | null => {
    return (
      formatProductsMenu.value.find(({ code }) => current.value === code) ||
      null
    );
  });

  const handleClick = (payload: IFormatProductMenu): void => {
    if (!validIsNuxtLink(payload)) {
      current.value = payload.code || '';
    }

    window.gtag('event', 'site_click', {
      Item: 'Navigation',
      Item_Cate: menuName.value.CN_PRODUCTS,
      Item_Name: payload.name,
    });
  };
</script>
